import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    display: 'block',
  },
  select: {
    minWidth: 200,
  },
  chartContainer: {
    margin: '14px 10px',
    backgroundColor: '#f8f8f8',
    borderRadius: '8px',
    padding: 10,
    overflow: 'auto',
  },
  chartView: {
    backgroundColor: '#f8f8f8',
  },
  chartName: {
    fontSize: '1.2em',
    fontWeight: 500,
  },
  viewName: {
    border: 'solid 1px #eee',
    borderRadius: '4px',
    padding: '4px 12px',
    display: 'inline-block',
    margin: 4,
    cursor: 'pointer',
  },
}));

export default useStyles;
